import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type CustomerPortalBundlesFlatTeamSettingGroupId =
  "customer_portal_bundles.overview";

const customerportalbundlesOwner: SettingOwner = {
  kind: "teamSettings",
  product: "returns",
};

const customerportalbundlesRisk: SettingRisk = {
  level: "medium",
  reason: "Bundle configuration is customer-facing.",
};

export const CustomerPortalBundlesFlatTeamSettingGroups = [
  {
    id: "customer_portal_bundles.overview",
    title: "Portal bundles",
    description: "Bundle configuration for the customer portal.",
    productArea: "returns",
    access: directMerchantAccess(
      SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    ),
    owner: customerportalbundlesOwner,
    risk: customerportalbundlesRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "customer-portal/bundles" },
    synonyms: ["portal bundles", "bundles", "bundle management"],
  },
] as const satisfies readonly SettingGroupDefinition<CustomerPortalBundlesFlatTeamSettingGroupId>[];

type _assertAllCustomerPortalBundlesFlatTeamSettingGroupsProvided =
  CustomerPortalBundlesFlatTeamSettingGroupId extends (typeof CustomerPortalBundlesFlatTeamSettingGroups)[number]["id"]
    ? true
    : never;
const _allCustomerPortalBundlesFlatTeamSettingGroupsProvided: _assertAllCustomerPortalBundlesFlatTeamSettingGroupsProvided = true;
void _allCustomerPortalBundlesFlatTeamSettingGroupsProvided;

export const CustomerPortalBundlesFlatTeamSettingGroupById: Record<
  CustomerPortalBundlesFlatTeamSettingGroupId,
  SettingGroupDefinition<CustomerPortalBundlesFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      CustomerPortalBundlesFlatTeamSettingGroupId,
      SettingGroupDefinition<CustomerPortalBundlesFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of CustomerPortalBundlesFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return map as Record<
    CustomerPortalBundlesFlatTeamSettingGroupId,
    SettingGroupDefinition<CustomerPortalBundlesFlatTeamSettingGroupId>
  >;
})();
